import script from "./MobileInventoryDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileInventoryDetail.vue?vue&type=script&setup=true&lang=js"

import "./MobileInventoryDetail.vue?vue&type=style&index=0&id=282b8a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-282b8a26"]])

export default __exports__